/*global Modernizr, google, currentMarker, console */
/*jslint browser:true */

(function() {
  'use strict';


  // get all ratings and convert to an array
  let ratings = document.querySelectorAll('.number-rating');
  let numArry = [];

  for (let i = 0; i < ratings.length; i++) {
    let num = parseInt(ratings[i].innerHTML);

      numArry.push(num);

  }


  // get ratings array and convert ratings to percentages
  Array.prototype.toPercentage = function() {
    var arr = this;
    return arr.map(function(d, i) {
      return (100 * d / arr.reduce((a, b) => a + b, 0)) | 0;
    });
  };

  let numsPercents = numArry.toPercentage();
  let ratingBars = document.querySelectorAll('.bar-inner');
  let ratingBarArrays = [];

  for (let x = 0; x < ratingBars.length; x++) {
    let bar = ratingBars[x];

      ratingBarArrays.push(bar);

  }

  let barChartObjects = [];
  ratingBarArrays.forEach(function(bar) {
      let singelBar = {};
      singelBar['type'] = bar;
      barChartObjects.push(singelBar);
  });

  barChartObjects.forEach((el,i) => {
    el.numsPercent = numsPercents[i];
  });


  // take all our work and display on front end
  function barChart() {
    var html = barChartObjects.map((obj, i) => {

      let number = 5 - i;
      let bar = obj.type;
      let getPercent = obj.numsPercent;
      let numberRating = obj.type.lastElementChild.innerHTML;

      if(number === 1) {
        number += ' Star&nbsp;';
      } else {
        number += ' Stars';
      }

			return `
        <div class='bar'>
          <div class="bar-inner">
      			<div class="label caption">${number}</div>
            <div class="bar-line-container">
              <div class="line" style='width:${getPercent}%;'></div>
            </div>
  					<div class="number-rating caption">(${numberRating})</div>
      		</div>
      	</div>
			`;
		}).join('');
    let chart = document.querySelector('div.chart');
    if(chart) {
      chart.innerHTML = html;
    }
  }

  barChart();

  let lines = document.querySelectorAll('.line');
  let chart = document.getElementById('chart');

  if(lines && chart) {

    var isInViewport = function (elem) {

      var bounding = elem.getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    };

    window.addEventListener('scroll', function() {
      if (isInViewport(chart)) {
        lines.forEach((line) => {
          line.classList.add('draw');
        });
      }
    });
  }

}());
